import { useState } from "react";
import Deploy from "./Deploy";
import DeployConfirmModal from "./DeployConfirmationModel";
import { requestWithToken } from "../utils/apis";
import { toast } from "react-toastify";
import { useAuth } from "../context/AuthContext";

const DeployTrigger = () => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [showDeploy, setShowDeploy] = useState(false);
  const { user } = useAuth();
  const projectId = user?.project_id;

  // Hide deploy button completely if disabled
  if (!user?.is_deploy_enable) return null;

  const handleDeployClick = () => {
    setShowConfirm(true);
  };
//   const handleConfirm = async () => {
//     setConfirming(true);

//     // simulate deploy API call or setup
//     setTimeout(() => {
//       setConfirming(false);
//       setShowConfirm(false);
//       setShowDeploy(true); // show the Deploy popup
//     }, 800);
//   };

  const handleConfirm = async () => {
    setConfirming(true);
    try {
      const response = await requestWithToken(
        "POST",
        `/api/deploy/code/${projectId}`
      );

      console.log("Deploy response:", response);

      if (response?.data?.status === 1) {
        toast.success(response.data.message || "Deployment triggered successfully!");
        setShowDeploy(true);
      } else {
        toast.error(response?.data?.message || "Deployment failed");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(error?.response?.data?.message || "Deployment API error");
    } finally {
      setConfirming(false);
      setShowConfirm(false);
    }
  };

  return (
    <>
      <button className="btn-white me-3" onClick={handleDeployClick}>
        Deploy
      </button>

      {/* Confirm Modal */}
      <DeployConfirmModal
        show={showConfirm}
        onClose={() => setShowConfirm(false)}
        onConfirm={handleConfirm}
        confirming={confirming}
      />

      {/* Deploy Popup */}
      {showDeploy && <Deploy onClose={() => setShowDeploy(false)} />}
    </>
  );
};

export default DeployTrigger;
